import { css } from '@/styled-system/css';

// `marginRight: auto` pushes the TrustSignal to the right of the same
// row on desktop. On mobile the parent `summaryRow` switches to
// `flex-direction: column`, so this margin is a no-op there.
export const container = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 'xs',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  marginRight: 'auto',
});
